import type {
  BanknoteInstance,
  BanknoteVisualProps,
  FakeVariantDefinition,
} from '../models/BanknoteTypes';

const PATTERN_COUNT = 4;

/**
 * Katalog varyasyon kurallarını instance özelliklerine uygular.
 */
export class FakeVariantApplicator {
  apply(
    source: BanknoteInstance,
    variant: FakeVariantDefinition,
  ): { visual: BanknoteVisualProps; serial: string } {
    const visual = { ...source.visual };
    let serial = source.serial;

    switch (variant.type) {
      case 'hue_offset':
        visual.hue = this.applyHueOffset(visual.hue, variant.min ?? 8, variant.max ?? 14);
        break;
      case 'pattern_change':
        visual.patternId = this.applyPatternChange(visual.patternId);
        break;
      case 'serial_digit_flip':
        serial = this.applySerialDigitFlip(serial, variant.digitIndex ?? serial.length - 1);
        break;
      default:
        break;
    }

    return { visual, serial };
  }

  private applyHueOffset(hue: number, min: number, max: number): number {
    const offset = min + Math.floor(Math.random() * (max - min + 1));
    return (hue + offset) % 360;
  }

  private applyPatternChange(currentPatternId: number): number {
    const alternatives = Array.from({ length: PATTERN_COUNT }, (_, index) => index).filter(
      (id) => id !== currentPatternId,
    );
    const index = Math.floor(Math.random() * alternatives.length);
    return alternatives[index] ?? (currentPatternId + 1) % PATTERN_COUNT;
  }

  private applySerialDigitFlip(serial: string, digitIndex: number): string {
    const chars = serial.split('');
    const index = Math.min(Math.max(digitIndex, 0), chars.length - 1);
    const current = chars[index];

    if (!current || !/\d/.test(current)) {
      return serial;
    }

    const nextDigit = String((Number(current) + 1) % 10);
    chars[index] = nextDigit;
    return chars.join('');
  }
}
